// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search__content[data-v-6740376c]{overflow-y:auto}.search--container[data-v-6740376c]{max-width:500px;margin:0 auto;z-index:5}.search-wrapper[data-v-6740376c]{min-height:150px;position:absolute;background-color:#fff;max-width:1200px;margin:0 auto;top:0;left:0;right:0;z-index:205}.search-wrapper .v-btn[data-v-6740376c]{position:absolute;right:0;top:0;margin:10px}", ""]);
// Exports
module.exports = exports;
